export default __webpack_public_path__ + "static/media/border-radius-bottom-right.30206f8b.svg";